import { useQuery } from '@tanstack/react-query';

import { FALLBACK_CATEGORIES } from '@/components/tickets/ticketConstants';
import { supportService, type SupportCategoryOption } from '@/services/supportService';

export interface SupportCategoriesState {
  routingEnabled: boolean;
  categories: SupportCategoryOption[];
  isLoading: boolean;
}

/** Categories a new ticket may use right now (backend routing flag). Falls back
 *  to today's technical|seo when the request fails, so the form always works. */
export function useSupportCategories(enabled = true): SupportCategoriesState {
  const query = useQuery({
    queryKey: ['support', 'categories'],
    queryFn: () => supportService.getCategories(),
    enabled,
    staleTime: 5 * 60_000,
    retry: false,
  });
  if (query.data && query.data.categories.length > 0) {
    return {
      routingEnabled: query.data.routing_enabled,
      categories: query.data.categories,
      isLoading: false,
    };
  }
  return { routingEnabled: false, categories: FALLBACK_CATEGORIES, isLoading: query.isLoading };
}
